import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Box, Card, makeStyles, Typography } from '@material-ui/core'
import clsx from 'clsx'

import api from '@micmnt/apis'
import LoadingCard from '@/components/LoadingCard'
import Planimetry from '@/components/Planimetry'
import { europeNum } from '@/utils/general'
import { basicColors } from '@/theme'
import { handleTabsChange, updatedPlantInfo } from '@/slices/pv/plantView'
import useAuth from '@/hooks/useAuth'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    height: '100%',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  },
  electricSchemeRoot: {
    width: '100%',
    height: '100%',
    borderRadius: theme.spacing(1)
  },
  cardRoot: {
    padding: theme.spacing(1, 2),
    marginBottom: theme.spacing(1)
  },
  canvaContainer: {
    minHeight: '100% !important',
    height: '100%'
  },
  warningBox: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 99,
    backgroundColor: basicColors.darkYellow,
    padding: 16,
    margin: 0,
    color: basicColors.darkText,
    textAlign: 'center'
  },
  glassBackground: {
    '@supports (backdrop-filter: none) or (-webkit-backdrop-filter: none)': {
      '-webkit-backdrop-filter': 'saturate(120%) blur(10px)',
      backdropFilter: 'saturate(190%) blur(16px)',
      backgroundColor: 'rgba(16, 26, 38, 0.6)'
    }
  }
}))

const ElectricScheme = ({ className }) => {
  const classes = useStyles()
  const { currentProject } = useAuth()
  const { uuid: plantId, name, electricScheme, infoBoxes, devices, plant, assets, plantType } = useSelector((state) => state.pvPlantView)
  const dispatch = useDispatch()

  // Stato locale per intercettare la modifica di infoboxes
  // infoBoxes al refresh della pagina è un oggetto vuoto
  const [fieldData, setFieldData] = useState({})

  useEffect(() => {
    const fetchPlantInfo = () => {
      if (plantId) {
        dispatch(updatedPlantInfo({ plantId, currentProject }))
      }
    }
    fetchPlantInfo()
    const overviewInterval = setInterval(fetchPlantInfo, 60000)

    return () => {
      clearInterval(overviewInterval)
    }
  }, [dispatch, plantId])

  useEffect(() => {
    setFieldData(infoBoxes)
  }, [infoBoxes])

  // funzione che prende le anomalie del singolo device
  const getDeviceAnomalies = async (deviceId) => {
    const { data: anomalies, error } = await api.get({
      savedUrl: 'anomaliesList',
      params: {
        limit: 3,
        sortby: 'startedAt',
        sortorder: 'DESC',
        plantId,
        relatedResources: `/devices/${deviceId}`,
        filter: JSON.stringify({ endedAt: { $exists: false } })
      }
    })

    if (error) {
      return null
    }
    return anomalies
  }

  return (
    <div className={classes.root}>
      <Card className={clsx(classes.cardRoot, classes.glassBackground)}>
        <Box mt={1}>
          <Typography variant='h4' component='div'>{`Schema Elettrico ${name || ''}`}</Typography>
        </Box>
      </Card>
      <Box height='calc(100% - 130px)'>
        <Card className={clsx(classes.electricSchemeRoot, className)}>
          <Box style={{ position: 'relative', height: '100%' }}>
            {electricScheme.draw && electricScheme.draw.length === 0
              ? (
                <Typography
                  component='p'
                  variant='body1'
                  className={classes.warningBox}
                >
                  Lo schema elettrico è vuoto, modificare l&apos;impianto per crearlo.
                </Typography>)
              : null}
            {electricScheme.draw
              ? (
                <Box position='relative' width='100%' height='100%'>
                  <Planimetry
                    formatter={europeNum}
                    className={classes.canvaContainer}
                    unselectable
                    fieldData={fieldData}
                    plantType={plantType}
                    assets={assets}
                    devices={devices}
                    goToAnomalies={() => dispatch(handleTabsChange('anomalies'))}
                    // selectAnomaly={(singleAnomaly) => {
                    //   setSelectedAnomaly(normalizeAnomaly(singleAnomaly, anomaliesCategoryStatus))
                    //   setOpenAnomalyDrawer(true)
                    // }}
                    getDeviceAnomalies={getDeviceAnomalies}
                    // openDeviceDetail={openDeviceDetail}
                    importedCanvas={electricScheme}
                  />
                </Box>
                )
              : (<LoadingCard glass />)}
          </Box>
        </Card>
      </Box>
    </div>
  )
}

export default ElectricScheme
